import React from 'react';
import { Icon } from 'panamera-react-ui';
var css = {
  "textRow": "oalp-3NG_u"
};
export var TextWithIcon = function TextWithIcon(_ref) {
  var style = _ref.style,
    textWithIcons = _ref.textWithIcons,
    title = _ref.title,
    subtitle = _ref.subtitle;
  if (textWithIcons && textWithIcons.length) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, title && title.text && /*#__PURE__*/React.createElement("div", {
      style: title.style
    }, title.text), subtitle && subtitle.text && /*#__PURE__*/React.createElement("div", {
      style: subtitle.style
    }, subtitle.text), /*#__PURE__*/React.createElement("div", {
      style: style
    }, textWithIcons.map(function (text, idx) {
      return /*#__PURE__*/React.createElement("div", {
        key: idx,
        className: css.textRow,
        style: text.textRowStyle
      }, text.icon ? /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Icon, {
        size: text.iconSize ? text.iconSize : 16,
        icon: text.icon,
        color: text.iconColor
      })) : null, /*#__PURE__*/React.createElement("span", {
        style: text.style
      }, text.text));
    })));
  }
  return null;
};
export default TextWithIcon;